enum LeadLoaderTypesEnum {
  CreateLead = 'CreateLead',
  UpdateLead = 'UpdateLead',
  PublishLead = 'PublishLead',
  SetLeadState = 'SetLeadState',
  DeleteLead = 'DeleteLead',
}

export default LeadLoaderTypesEnum;
